import { useEffect } from 'react';
import { useLocation } from '@reach/router';

import { useCookieConsent } from '~/context/CookieConsentContext';

function loadYouTubeEmbeds(): void {
  const iframes = document.querySelectorAll<HTMLIFrameElement>(
    '.youtube-embed iframe[data-src]'
  );
  iframes.forEach((iframe) => {
    const src = iframe.getAttribute('data-src');
    if (src) {
      iframe.src = src;
      iframe.removeAttribute('data-src');
    }
    iframe.closest('.youtube-embed')?.removeAttribute('data-pending-consent');
  });
}

const YouTubeEmbedLoader: React.FC = () => {
  const { consentStatus } = useCookieConsent();
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      consentStatus === 'accepted' &&
      document.querySelector('.youtube-embed iframe[data-src]') !== null
    ) {
      loadYouTubeEmbeds();
    }
  }, [consentStatus, pathname]);

  return null;
};

export default YouTubeEmbedLoader;
